import classNames from 'classnames/bind';
import React from 'react';
import Tooltip from '../Tooltip';
import colors from '../../scss/_colors-export.module.scss';

import styles from './Chip.module.scss';

const cx = classNames.bind(styles);

interface ChipProps {
  label?: string;
  dataTestId?: string;
  short?: boolean;
  color?: string;
  backgroundColor?: string;
}

const Chip = ({
  label,
  dataTestId,
  short,
  color = colors.primary800,
  backgroundColor = colors.primary100,
}: ChipProps): React.ReactElement | null => {
  if (!label) {
    return null;
  }
  const text = short ? label.substring(0, 1) : label;
  const tag = (
    <div className={cx('body', { 'is-short': short })} style={{ backgroundColor, color }} data-testid={dataTestId}>
      {text}
    </div>
  );
  return short ? <Tooltip content={label}>{tag}</Tooltip> : tag;
};

export default Chip;
